import { OrganizationGroupType } from 'api/adgang/models';

export const permanentOrganizationGroups = [
  OrganizationGroupType.Kommune,
  OrganizationGroupType.Statsforvalteren
];
